import { get } from 'lodash'
import getPath from '../../lib/getPath'

export default (item, key, defaultPath = '/') => {
  return (
    get(item, `${key}.url`) ||
    getPath(get(item, `${key}.document`), defaultPath)
  )
}
